import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getPositionDevices(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.POSITION_DEVICES,dtConfig[ModulesMap.POSITION_DEVICES].getPositionDevices,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}

function getFulledPositionDevices(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.POSITION_DEVICES,dtConfig[ModulesMap.POSITION_DEVICES].getFulledPositionDevices,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}

function getPositionDevice(companyId, deviceId) {
	return dataTransferWrap(ModulesMap.POSITION_DEVICES,dtConfig[ModulesMap.POSITION_DEVICES].getPositionDevice, {
		urlParams: {
			companyId,
			deviceId,
		},
	})
}


export default {

	getPositionDevices,
	getFulledPositionDevices,
	getPositionDevice,

}
